/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

export const CHANGE_USERNAME = "boilerplate/Home/CHANGE_USERNAME";
export const ON_CALL_UPLOAD = "boilerplate/Landing/ON_CALL_UPLOAD";
export const PASS_INV_VAL = "boilderplate/NewB2CInvoice/PASS_INV_VAL";
export const RESET_FETCH_PASS = "boilerplate/NewB2CInvoice/RESET_FETCH_FAILED";
export const ON_NOTIFY = "boilerplate/NewB2CInvoice/ON_NOTIFY";
export const LOADER_STATUS = "boilderplate/NewB2CInvoice/LOADER_STATUS";
export const TOTAL_RECORD = "boilerplate/NewB2CInvoice/TOTAL_RECORD";
export const GET_ITEM = "boilderplate/NewB2CInvoice/GET_ITEM";
export const TOTAL_ITEM_RECORDS =
  "boilderplate/NewB2CInvoice/TOTAL_ITEM_RECORDS";
export const TXN_RECORD = "boilerplate/NewB2CInvoice/TXN_RECORD";
export const DISABLE_EDIT = "boilderplate/NewB2CInvoice/DISABLE_EDIT";
export const SET_PASS_PAGE = "boilerplate/NewB2CInvoice/SET_PASS_PAGE";

export const SET_PDF_MODAL = "boilerplate/NewB2CInvoice/SET_PDF_MODAL";
export const SET_B2C_RECORDS = "boilerplate/NewB2CInvoice/SET_B2C_RECORDS";
